import { Injectable } from "@angular/core";
import { PositionProfile } from "../models/position-profile.model";
import { DefaultDataService } from "./default-data.service";
import { HttpClient } from "@angular/common/http";
import { StateService } from "./state.service";
import { Observable } from "rxjs";
import { QuestionCategory } from "../models/question-category.model";
import { Result } from "../models/general/result.model";

@Injectable({
    providedIn: 'root'
})
export class PositionProfileService extends DefaultDataService<PositionProfile> {
    
    constructor(
        http: HttpClient, 
        stateService: StateService,
    ) 
    {
        super(http, stateService);
        this.controllerName = 'position-profile';
    }
    
    getListForCreate(positionId: number): Observable<QuestionCategory[]> {
        return this.get<QuestionCategory[]>(`/api/${this.controllerName}/list-for-create/${positionId}`);
    }

    save(model: PositionProfile): Observable<Result<PositionProfile>> {
        return this.post<Result<PositionProfile>>(`/api/${this.controllerName}/save`, model);
    }
}